import * as types from './mutation-types'
import Vue from 'vue'
import { IMissionGlobalState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbMissionGlobal, IAloDbMissionGlobalConstParam, isAloDbMissionGlobalCoverage, isAloDbMissionGlobalFormation, isAloDbMissionGlobalSimulation } from '@/models/alodb/AloDbMissionGlobal';
import glider from '@/api/glider';
import { SIMULATIONS_DETAIL_TABS, SimulationTabs } from '@/models/ui/SimulationTabs';
import { UiTab } from '@/models/ui/UiTab';
import {i18n} from '@/locale/vueI18n'
import { SimulationMode } from '@/enum/SimulationMode';
import { ISmartSimulation } from '@/models/iris/smartMission/ISmartSimulation';
import { WobAdminChanged } from '@/models/wob/WobAdminChanged';

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IMissionGlobalState> = {
     
    //Gestion des recherches de missions
    [types.MISSIONGLOBAL_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.missionGlobalLoading = true
    },
    [types.MISSIONGLOBAL_SUCCESS]: (state, missionGlobals:Array<AloDbMissionGlobal>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        missionGlobals.forEach(m => Vue.set(state.missionGlobalById,m.MIG_ID!,m))
        state.missionGlobalsId = missionGlobals.map(m => m.MIG_ID!)
        state.missionLoaded = true
        state.missionGlobalLoading = false             
    },
    [types.MISSIONGLOBAL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.missionGlobalsId = []
        state.missionGlobalLoading = false
    },
    [types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${itemId}`}).toString()
        state.missionGlobalLoading = true
    },
    [types.MISSIONGLOBAL_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.missionGlobalLoading = false
    },
    [types.MISSIONGLOBAL_SELECT_DETAIL_SUCCESS]: (state,missionGlobal:AloDbMissionGlobal) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${missionGlobal.MIG_ID}`}).toString()
                
        //1, on met à jour de m'missionGlobal dans la liste des missionGlobals
        Vue.set(state.missionGlobalById,missionGlobal.MIG_ID!,missionGlobal)
        if(!state.missionGlobalsId.includes(missionGlobal.MIG_ID!)) state.missionGlobalsId.push(missionGlobal.MIG_ID!)
        
        state.missionGlobalLoading = false
        
    },
    [types.MISSIONGLOBAL_OPEN_DETAIL]: (state,missionGlobal:AloDbMissionGlobal) => {        
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${missionGlobal.MIG_ID}`}).toString()    
        
        const newIdx = state.detailSimulations.findIndex(id => id == missionGlobal.MIG_ID)
        if (newIdx == -1) {                 
            state.detailSimulations.push(missionGlobal.MIG_ID!)                          
        } 
        
        state.currentMissionGlobalId = missionGlobal.MIG_ID

        
    },    
    [types.MISSIONGLOBAL_SELECT_DETAIL]: (state,missionGlobal:AloDbMissionGlobal) => {                
        state.currentMissionGlobalId = missionGlobal.MIG_ID        
    },
    [types.MISSIONGLOBAL_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${libelle}`}).toString()
        state.missionGlobalLoading = true
    },
    [types.MISSIONGLOBAL_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.missionGlobalLoading = false
    },
    [types.MISSIONGLOBAL_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${libelle}`}).toString()
        state.missionGlobalLoading = true
    },
    [types.MISSIONGLOBAL_DELETE_SUCCESS]: (state,migId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${migId}`}).toString()
        const index = state.missionGlobalsId.findIndex(l => l == migId)
        state.missionGlobalsId.splice(index == -1 ? state.missionGlobalsId.length : index, index == -1 ? 0 : 1)
        state.missionGlobalById[migId] && Vue.delete(state.missionGlobalById,migId)
        state.missionGlobalLoading = false
    },
    [types.MISSIONGLOBAL_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.missionGlobalLoading = false
    },
    [types.MISSIONGLOBAL_RUN_SIMULATION_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.LaunchSimulation').toString()} ${libelle}`}).toString()
        state.missionGlobalLoading = true
    },
    [types.MISSIONGLOBAL_RUN_SIMULATION_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorOnSimulation').toString()        
        state.missionGlobalLoading = false
    },      
    [types.MISSIONGLOBAL_ABORT_SIMULATION_REQUEST]: (state,libelle:string) => {
        state.status = `abort simulation ${libelle}`
        state.missionGlobalLoading = true
    },
    [types.MISSIONGLOBAL_ABORT_SIMULATION_ERROR]: state => {
        state.status = 'error aborting simulation'
        state.missionGlobalLoading = false
    },    
    [types.MISSIONGLOBAL_SET_MODIFIED_ADM]: (state, missionGlobal:AloDbMissionGlobal) => {    
        const modified = new AloDbMissionGlobal({...missionGlobal} as IAloDbMissionGlobalConstParam)
        if(modified.MIG_ID) {
            Vue.set(state.modifideMissionGlobalById,modified.MIG_ID,modified)
        }
        else state.newModifiedAdmMissionGlobal = modified
    },
    [types.MISSIONGLOBAL_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },   
    [types.MISSIONGLOBAL_UNSELECT_DETAIL]: (state, id:number) => {
        const newIdx = state.detailSimulations.findIndex(simId => simId == id)
        if (newIdx > -1) {
            //reset des données sciences et navigation...
            // const missionGlobal = state.detailSimulations[newIdx].missionGlobal        
            // if (missionGlobal._dataScienceLoaded) {
            //     missionGlobal._dataScienceLoaded = false
            //     //vide les données sciences
            //     missionGlobal.dataScience.length = 0
            // }
            // if (missionGlobal._dataNavigationLoaded) {
            //     missionGlobal._dataNavigationLoaded = false
            //     //vide les données de navigation
            //     missionGlobal.dataNavigation.length = 0
            // }
            // if (missionGlobal._downloadFileStatusLoaded) {
            //     missionGlobal._downloadFileStatusLoaded = false
            //     //vide les données de navigation
            //     missionGlobal.downloadFileStatus!.length = 0
            // }            
            state.detailSimulations.splice(newIdx, 1)
        }
    },
    [types.SIMULATION_SYNC_MISSSIONPLAN_SENSOR]: (state, missionGlobal:AloDbMissionGlobal) => {            
        //seulement si on est en mode simulation
        if(isAloDbMissionGlobalSimulation(missionGlobal) || isAloDbMissionGlobalFormation(missionGlobal))
        {
            const config = missionGlobal.config!
            //@ts-ignore
            const payload = config?.gliders_config?.at(0)?.payload
            const nextId = Math.max(...config?.mission_plan?.payload?.map(i => i.id),0) + 1        
            const deletingIds = config.mission_plan.payload.filter(p => payload?.every((s:string) => s != p.snr_label)).map(p => p.id)
            
            config.mission_plan.payload = [
            ...config!.mission_plan.payload.filter(p => payload?.some((s:string) => s == p.snr_label)),
            ...(payload?.filter((s:string) => config.mission_plan.payload.every(p => p .snr_label != s))?.map((s:string,idx:number) => ({
                id:nextId+idx,
                snr_label:s
            }))??[])
            ]
        
            if(isAloDbMissionGlobalSimulation(missionGlobal)) {
                const insertedIds = config.mission_plan.payload.filter(p => p.id >= nextId).map(p => p.id)
            
                config.mission_plan.prf_sci.forEach(p => {                        
                    deletingIds.forEach(id => delete p.sensors[id] )
                    insertedIds.forEach(id => p.sensors[id] = [1,"111",1])
                    const keyToDelete = Object.keys(p.sensors).filter(k => isNaN(Number.parseInt(k)))
                    //@ts-ignore
                    keyToDelete.forEach(id => delete p.sensors[id] )            
                })
            }

        }   
        if(isAloDbMissionGlobalCoverage(missionGlobal) || isAloDbMissionGlobalFormation(missionGlobal)) {                        
            missionGlobal.config?.gliders_config?.forEach(g => {
                //@ts-ignore
                if(g.prf_sci?.length) {
                    //@ts-ignore
                    g.prf_sci?.forEach(p => {
                        p.sensors = g.payload.reduce((acc:{[key:string]:[number,string,number]},s:string) => {
                            acc[s] = p.sensors[s] ?? [1,"111",1]
                            return acc
                        },{})   
                    })
                }
                else{
                    //@ts-ignore
                    g.prf_sci = [{
                        id:1,
                        prf_label:"default",
                        sensors:g.payload.reduce((s,p) => {s[p] = [1,"111",1]; return s},{} as {[key:string]:[number, string, number]})
                      }] 
                }
            })
        }
}   ,
    [types.MISSIONGLOBAL_EXTERNAL_UPDATE]: (state, wob: WobAdminChanged<AloDbMissionGlobal>) => {        
        //on supprime de la liste
        if(wob.actionType == "Deleted") {
            const index = state.missionGlobalsId.findIndex(m => m == wob.oldAloDbItem.MIG_ID)
            state.missionGlobalsId.splice(index == -1 ? state.missionGlobalsId.length : index, index == -1 ? 0 : 1)
            state.missionGlobalById[wob.oldAloDbItem.MIG_ID!] && Vue.delete(state.missionGlobalById,wob.oldAloDbItem.MIG_ID!)
        }
    }
}


export default mutations